import { RemiSeparator } from "@remi/next-ui";

import { useUserOrgType } from "~/hooks/useUserOrgType";
import { ContactDetailsCard } from "./components/ContactDetailsCard";
import { ContactHeader } from "./components/ContactHeader";
import { ContactMethodButtons } from "./components/ContactMethodButtons";
import { PersonNoteSection } from "./components/PersonNoteSection";

type HomeownerPersonCardProps = {
  personId: string;
  showButtons?: boolean;
};

export const HomeownerPersonCard = ({ personId, showButtons = true }: HomeownerPersonCardProps) => {
  const { isRemiUser } = useUserOrgType();

  return (
    <>
      <ContactHeader personId={personId} showButtons={showButtons} />
      {isRemiUser && (
        <>
          <RemiSeparator orientation="horizontal" className="w-full" />
          <ContactDetailsCard personId={personId} showButtons={showButtons} />
          <PersonNoteSection personId={personId} />
          {showButtons && <ContactMethodButtons personId={personId} />}
        </>
      )}
    </>
  );
};
